import { withStylePrefix } from '../common/withStylePrefix';
import { ChatStackComponent, chatStackTemplate } from './ChatStack';
import styles from './ChatStack.styles.scss';
export const chatStackDefinition = {
    baseName: 'chat-stack',
    template: chatStackTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonChatStack = ChatStackComponent.compose(chatStackDefinition);
